import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './ApplianceDiscStyles';
import Disc from './Disc';

export default class ApplianceDisc extends Component {
  render() {
    return (
      <a href={`/my-home/appliance/${this.props.id}`} className={css(styles.container)}>
        <div className={css(styles.discWrapper)}>
          <Disc {...this.props} />
        </div>
        <span className={css(styles.title)}>{this.props.title}</span>
        {this.props.state === 'on' && <span className={css(styles.onHightlight)}>On</span>}
      </a>
    );
  }
}
